export default function WMSMaps() {

	var wmsMaps = [
		{
			category:"germany",
			label: "Deutschland",
			hidden:false,
			urls: [

				{
					label:"Standard Karte (TopPlusOpen)",
					size:1126,
					hidden:false,
					legalShort:"© Bundesamt für Kartographie und Geodäsie 2025",
					legal:"Die Daten sind urheberrechtlich geschützt. Die Kartendarstellung und Präsentationsgraphiken werden entgeltfrei mit der Datenlizenz Deutschland – Namensnennung – Version 2.0 (https://www.govdata.de/dl-de/by-2-0) zur Verfügung gestellt. Der Quellenvermerk ist zu beachten. | Quellenvermerk: Kartendarstellung und Präsentationsgraphiken: © Bundesamt für Kartographie und Geodäsie 2025, Datenquellen: https://sg.geodatenzentrum.de/web_public/gdz/datenquellen/Datenquellen_TopPlusOpen.html",
					url:"https://sgx.geodatenzentrum.de/wms_topplus_open?service=WMS&version=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=web_grau&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Satellitenbilder Deutschland 10m Auflösung (Sentinel-Date 2021)",
					size:1126,
					hidden:false,
					legalShort:"© Europäische Union, enthält veränderte Copernicus Sentinel-Daten (2021)",
					legal:"Rechtlicher Hinweis zur Verwendung von Copernicus Sentinel-Daten und Diensteinformationen (https://sg.geodatenzentrum.de/web_public/gdz/lizenz/deu/Sentinel_Data_Legal_Notice_deu.pdf). Der Quellenvermerk ist zu beachten. || Quellenvermerk: Europäische Union, enthält veränderte Copernicus Sentinel-Daten (aktuelles Jahr)",
					url:"https://sgx.geodatenzentrum.de/wms_sen2europe?service=WMS&version=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=rgb&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Alle Schutzgebiete Deutschlands (BfN)",
					size:1126,
					hidden:false,
					legalShort:"© Bundesamt für Naturschutz (BfN) 2025",
					legal:"Bundesamt für Naturschutz (BfN) 2025",
					url:"https://geodienste.bfn.de/ogc/wms/schutzgebiet?VERSION=2.0&REQUEST=GetMap&SERVICE=WMS&FORMAT=image%2Fpng&LAYERS=Landschaftsschutzgebiete&CRS=EPSG%3A3857&STYLES=default&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},

			]
		},
		{
			category:"BB",
			label: "Brandenburg",
			hidden:false,
			urls: [
				{
					label:"Liegenschaften (INSPIRE)",
					size:1126,
					hidden:false,
					legalShort:"© GeoBasis-DE/LGB, dl-de/by-2-0, (2025)",
					legal:"© GeoBasis-DE/LGB, dl-de/by-2-0, (Daten geändert)",
					url:"https://inspire.brandenburg.de/services/cp_alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=CP.CadastralZoning%2CCP.CadastralParcel&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		},
		{
			category:"MV",
			label: "Mecklenburg-Vorpommern",
			hidden:false,
			urls: [
				{
					label:"Digitale Orthophotos MV",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/adv_dop?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=mv_dop&CRS=EPSG%3A3857&STYLES=default&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Flurstücke (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_flurstuecke&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Gemarkungen (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/dfg_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=gema&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Bauwerke und Einrichtungen (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_bauw_einricht&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Gebäude (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_gebaeude&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Relief (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_relief&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Verkehr (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_verkehr&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Vegetation (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_vegetation&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Gewässer (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_gewaesser&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Siedlung (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:" © GeoBasis-DE/M-V 2023",
					legal:" © GeoBasis-DE/M-V 2023",
					url:"https://www.geodaten-mv.de/dienste/alkis_wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&LAYERS=adv_alkis_siedlung&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		},
		{
			category:"NI",
			label: "Niedersachsen",
			hidden:false,
			urls: [
				{
					label:"Liegenschaften (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:"© GLN (2024) Creative Commons Namensnennung – 4.0 International (CC BY 4.0)",
					legal:"Es gelten die Lizenzbedingungen „Creative Commons Namensnennung – 4.0 International (CC BY 4.0)“ bzw. „cc-by/4.0” (http://creativecommons.org/licenses/by/4.0/) mit den dort geforderten Angaben zum Quellenvermerk. Als Rechteinhaber und Bereitsteller ist „LGLN“, sowie das Jahr des Datenbezugs in Klammern anzugeben. Beispiel für Quellenvermerk: LGLN (2024) Creative Commons Namensnennung – 4.0 International (CC BY 4.0)",
					url:"https://opendata.lgln.niedersachsen.de/doorman/noauth/alkis_wms?VERSION=1.3.0&REQUEST=GetMap&SERVICE=WMS&FORMAT=image%2Fpng&LAYERS=ALKIS&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
			]
		},
		{
			category:"NW",
			label: "Nordrhein-Westfalen",
			hidden:false,
			urls: [
				{
					label:"Liegenschaften (INSPIRE)",
					size:1126,
					hidden:false,
					legalShort:"© Datenlizenz Deutschland – Zero – Version 2.0",
					legal:"Datenlizenz Deutschland – Zero – Version 2.0",
					url:"https://www.wms.nrw.de/geobasis/wms_nw_inspire-flurstuecke_alkis?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=CP.CadastralZoning%2CCP.CadastralParcel&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Bodenbewegungskataster (Copernicus Sentinel-1 Daten 2022-2023)",
					size:1126,
					hidden:false,
					legalShort:"Enthält modifizierte Copernicus Sentinel-1 Daten [2022-2023], verarbeitet durch Geobasis NRW; dl-de/by-2-0",
					legal:"Enthält modifizierte Copernicus Sentinel-1 Daten [2022-2023], verarbeitet durch Geobasis NRW; dl-de/by-2-0 (www.govdata.de/dl-de/by-2-0); https://www.wms.nrw.de/geobasis/wms_nw_bodenbewegungskataster.",
					url:"https://www.wms.nrw.de/geobasis/wms_nw_bodenbewegungskataster?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=nw_bb&CRS=EPSG%3A3857&STYLES=default&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				},
				{
					label:"Erneuerbare Energien",
					size:1126,
					hidden:false,
					legalShort:"© Datenlizenz Deutschland – Zero – Version 2.0",
					legal:"Datenlizenz Deutschland – Zero – Version 2.0",
					url:"https://www.wms.nrw.de/umwelt/erneuerbare_energien_nrw?SERVICE=WMS&version=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=wms_ee_03_2015_1&SRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		},
		{
			category:"RH",
			label: "Rheinland-Pfalz",
			hidden:false,
			urls: [
				{
					label:"Liegenschaften (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:"©GeoBasis-DE / LVermGeoRP (2025), dl-de/by-2-0",
					legal:"©GeoBasis-DE / LVermGeoRP (2025), dl-de/by-2-0, http://www.lvermgeo.rlp.de 2025; Es gelten folgende Regelungen zu Gewährleistung und Haftung; URL: https://lvermgeo.rlp.de/geodaten-geoshop/open-data/gewaehrleistung-haftung",
					url:"https://geo5.service24.rlp.de/wms/liegenschaften_rp.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=WMS_RP_ALKIS_Liegenschaften&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		},
		{
			category:"ST",
			label: "Sachsen-Anhalt",
			hidden:false,
			urls: [
				{
					label:"Liegenschaften (ALKIS)",
					size:1126,
					hidden:false,
					legalShort:"@ GeoBasis-DE / LVermGeo St",
					legal:"Datenlizenz Deutschland – Namensnennung – Version 2.0",
					url:"https://www.geodatenportal.sachsen-anhalt.de/wss/service/ST_LVermGeo_ALKIS_WMS_AdV_konform_App/guest?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=adv_alkis_flurstuecke,Farbe&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		},
		{
			category:"SN",
			label: "Sachsen",
			hidden:false,
			urls: [
				{
					label:"Katastergrundstücke (INSPIRE)",
					size:1126,
					hidden:false,
					legalShort:"© Geodaten Sachsen",
					legal:"Dieser Dienst kann gemäß den Nutzungsbestimmungen von Datenlizenz Deutschland – Namensnennung – Version 2.0 (https://www.govdata.de/dl-de/by-2-0) unter Angabe der Quelle: \"Geodaten Sachsen\" genutzt werden",
					url:"https://geodienste.sachsen.de/iwms_geosn_flurstuecke/guest?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=CP.CadastralZoning%2CCP.CadastralParcel&CRS=EPSG%3A3857&STYLES=&WIDTH=1126&HEIGHT=1126&BBOX={bbox-epsg-3857}",
				}
			]
		}
	];

	return wmsMaps;


}
